import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { HotelResultData, ImageResultData } from '@hiptraveler/data-access/api';

@Component({
  selector: 'about-hotel, about-food',
  template: `
    <div class="about-hotel ht-dialog-elevation" *ngIf="hotel?.description || hotel?.otherInfo || image?.imgDesc">
      <ng-container *ngIf="hotel">
        <h2 translate="search-result.about-this-hotel"></h2>
      </ng-container>
      <ng-container *ngIf="image">
        <h2 translate="search-result.about-this-place"></h2>
      </ng-container>

      <div class="about-hotel--message-content">
        <span *ngIf="hotel?.description" [formatDescription]="hotel?.description"></span>
        <span *ngIf="hotel?.otherInfo" class="italic" [formatDescription]="hotel?.otherInfo"></span>
        <span *ngIf="image?.imgDesc" [formatDescription]="image?.imgDesc"></span>
      </div>
    </div>
  `,
  styles: [`
    .about-hotel--message-content {
      display: flex;
      flex-direction: column;
      gap: 12px;

      p:not(:last-of-type ) {
        margin-bottom: 10px;
      }
    }
    .about-hotel--message-content .italic {
      font-style: italic;
    }
  `],
  host: { class: 'content' }
})
export class AboutResultComponent implements OnInit {

  @Input() hotel?: HotelResultData;
  @Input() image?: ImageResultData;

  constructor(
    private element: ElementRef<HTMLElement>,
  ) { }

  ngOnInit(): void {
    if (this.hotel?.description || this.hotel?.otherInfo || this.image?.imgDesc) return;

    this.element.nativeElement.style.display = 'none';
  }

}
